import React, { useEffect, useState } from 'react';
import api from '../api';

function AdminKYC() {
  const [kycs, setKycs] = useState([]);

  useEffect(() => {
    api.get('/api/admin/kyc')
      .then(res => setKycs(res.data))
      .catch(err => console.error('AdminKYC error:', err));
  }, []);

  const handleAction = async (id, status) => {
    try {
      await api.patch(`/api/admin/kyc/${id}`, { status });
      setKycs(prev => prev.map(k => k.id === id ? { ...k, status } : k));
    } catch (err) {
      alert(err.response?.data?.error || 'Action failed');
    }
  };

  return (
    <div>
      <h2>KYC Verification Management</h2>
      {kycs.length === 0 ? (
        <p>No KYC submissions.</p>
      ) : (
        <div className="table-box">
          <table>
            <thead>
              <tr>
                <th>User</th>
                <th>Full Name</th>
                <th>Document</th>
                <th>Status</th>
                <th>Action</th>
              </tr>
            </thead>
            <tbody>
              {kycs.map(k => (
                <tr key={k.id}>
                  <td>{k.User?.email}</td>
                  <td>{k.fullName}</td>
                  <td>{k.documentType} – {k.documentNumber}</td>
                  <td style={{ color: k.status === 'verified' ? 'green' : k.status === 'rejected' ? 'red' : 'orange' }}>
                    {k.status}
                  </td>
                  <td>
                    {k.status === 'pending' && (
                      <>
                        <button
                          onClick={() => handleAction(k.id, 'verified')}
                          style={{ background: '#10b981', color: 'white', border: 'none', padding: '0.25rem 0.5rem', borderRadius: '0.25rem', marginRight: '0.5rem', cursor: 'pointer' }}
                        >
                          Approve
                        </button>
                        <button
                          onClick={() => handleAction(k.id, 'rejected')}
                          style={{ background: '#ef4444', color: 'white', border: 'none', padding: '0.25rem 0.5rem', borderRadius: '0.25rem', cursor: 'pointer' }}
                        >
                          Reject
                        </button>
                      </>
                    )}
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      )}
    </div>
  );
}
export default AdminKYC;